module.exports = __webpack_public_path__ + "static/img/img_result_check.c0c8006.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mall/img_result_check.webp
// module id = Vq5q
// module chunks = 1